import type { IAppConfiguration } from '@app/utils/configuration';
import { getAppConfiguration } from '@app/utils/configuration';
import { useState } from 'react';

export default function useConfiguration() {
  const [state] = useState<IAppConfiguration>(getAppConfiguration());

  return state;
}
